define([
  "globals",
  "jquery",
  "local-storage",
  "js-cookie",
  "../../../react/site-bdc/catalog/index",
  "../../../react/site-bdc/catalog/api/CatalogApi",
  "jquery-history",
],
  function (globals, $, LocalStorage, Cookies, BootstrapReact, CatalogApi) {

    "use strict";

    const catalogApi = CatalogApi.default;

    var setEstimateFilters = function () {
      var widthWhole = $("#bdc-estimate-search-width-whole-select");
      var heightWhole = $("#bdc-estimate-search-height-whole-select");
      var sortBy = $("#bdc-estimate-search-sortby-select");

      var widthText = $("#bdc-estimate-search-width-whole-text");
      var heightText = $("#bdc-estimate-search-height-whole-text");
      var sortByText = $("#bdc-estimate-search-sortby-text");

      if (widthWhole && widthText) {
        $(widthText).html("Width (in): <strong> " + widthWhole.val() + "</strong>");
      }

      if (heightWhole && heightText) {
        $(heightText).html("Height (in): <strong>" + heightWhole.val() + "</strong>");
      }

      if (sortBy && sortByText) {
        $(sortByText).html("Sort By: <strong>" + $(sortBy).find(":selected").text() + "</strong>")
      }
    }

    $(function () {

      var useDelorean = globals.siteId === 3;

      const fave = () => {
        document.addEventListener('loginStatusChange', (e) => {
          if (e.detail.isLoggedIn) {
            getFavoritedProducts();
            $('.gcc-fave-button').show();
          }
        });

        $('.gcc-fave-button').show();

        BootstrapReact.default();
        const getFavoritedProducts = () => {
          var allItems = $('.bdc-productsearch-item');
          var productIds = new Array();
          $.each(allItems, function (key, value) {
            productIds.push(value.attributes["data-productid"].value);
          });
          getFavoritedProduct(productIds);
        }

        const setFavoriteProduct = (productIds) => {
          $.each(productIds, function (key, value) {
            $('li.bdc-productsearch-item[data-productid=' + value + '] .favorite-button').addClass('bg-green');
          })
        };

        const getFavoritedProduct = (productIds) => {
          const qs = productIds.map((x) => {
            return `ids=${x}`;
          }).join('&');

          catalogApi.getFavoritedProduct(qs).then((response) => {
            setFavoriteProduct(response.data.FavoritedProducts);
          })
        };

        getFavoritedProducts();

        const faveProduct = (productId, favorite, doneCallback, failCallback) => {
          return catalogApi.faveProduct(productId, favorite).then((response) => {
            doneCallback(response.data, productId, favorite);
          }).catch((error) => {
            failCallback(error, productId, favorite);
          });
        };

        const doneCallback = (response, productId, favorite) => {
          if (favorite) {
            $("li[data-productid='" + productId + "']")
              .find('.favorite-button').addClass('bg-green');
          } else {
            $("li[data-productid='" + productId + "']")
              .find('.favorite-button').removeClass('bg-green');
          }
        }

        const failCallback = function (error, productId, favorite) {
          if (error.response.status === 401) {
            const loginEvent = new CustomEvent('loginRequested', {
              "detail": {
                taskName: 'favorite',
                favorite: favorite,
                productId: productId
              }
            });
            document.dispatchEvent(loginEvent);
          }
        }

        $('.favorite-button').click((e) => {
          const productId = $(e.currentTarget).closest('.bdc-productsearch-item').data('productid');
          const isFavorite = $(e.currentTarget).closest('.favorite-button').hasClass('bg-green');
          const toggleTask = isFavorite ? 'unfavorite' : 'favorite';

          faveProduct(
            productId,
            toggleTask === 'favorite',
            doneCallback,
            failCallback,
          );
        });

        document.addEventListener('loginCompleted', (e) => {
          if (e.detail.taskName === 'favorite') {
            faveProduct(e.detail.productId, e.detail.favorite, doneCallback, failCallback);
            getFavoritedProducts();
          }
        });
      }

      if (useDelorean) {
        fave();
      }

      /* PRIVATE VARIABLES AND METHODS */
      var localStorage = new LocalStorage();

      setEstimateFilters();

      var showLoader = function () {
        $("#gcc-bca-search-results-loader").removeClass('dn');
        $(".gcc-loading").css('display', 'block');
      }
      var persistHeightWidth = function () {

        var widthWhole, widthEigth, heightWhole, heightEigth, minWidth, maxWidth, minHeight, maxHeight;

        if (globals.isEstimateSearch) {
          widthWhole = $("#bdc-estimate-search-width-whole-select").val();
          widthEigth = undefined;
          heightWhole = $("#bdc-estimate-search-height-whole-select").val();
          heightEigth = undefined;

          minWidth = $("#bdc-estimate-search-width-whole-select option:first").val();
          maxWidth = $("#bdc-estimate-search-width-whole-select option:last").val();

          minHeight = $("#bdc-estimate-search-height-whole-select option:first").val();
          maxHeight = $("#bdc-estimate-search-height-whole-select option:last").val();

        } else {

          widthWhole = $("#SelectedWidth").val();
          widthEigth = $("#SelectedWidthEigth").val();
          heightWhole = $("#SelectedHeight").val();
          heightEigth = $("#SelectedHeightEigth").val();

          minWidth = $("#SelectedWidth option:first").val();
          maxWidth = $("#SelectedWidth option:last").val();

          minHeight = $("#SelectedHeight option:first").val();
          maxHeight = $("#SelectedHeight option:last").val();
        }

        if (widthEigth == undefined) {
          widthEigth = 0;
        }
        if (heightEigth == undefined) {
          heightEigth = 0;
        }

        var width = parseFloat(widthWhole) + parseFloat(widthEigth / 8);
        var height = parseFloat(heightWhole) + parseFloat(heightEigth / 8);

        var widthStorage = {
          LocalStoragePersister: {},
          minDimension: minWidth,
          maxDimension: maxWidth,
          serializableValue: width,
          getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
        };
        var heightStorage = {
          LocalStoragePersister: {},
          minDimension: minWidth,
          maxDimension: maxWidth,
          serializableValue: height,
          getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
        };
        localStorage.persist("SELECTED_WIDTH_STORAGE_KEY", widthStorage);
        localStorage.persist("SELECTED_HEIGHT_STORAGE_KEY", heightStorage);

        Cookies.set("widthz", width);
        Cookies.set("hghtz", height);
      };

      var updateQueryString = function (key, value, url) {
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
          hash;

        if (re.test(url)) {
          if (typeof value !== "undefined" && value !== null)
            return url.replace(re, "$1" + key + "=" + value + "$2$3");
          else {
            hash = url.split("#");
            url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
            if (typeof hash[1] !== "undefined" && hash[1] !== null)
              url += "#" + hash[1];
            return url;
          }
        } else {
          if (typeof value !== "undefined" && value !== null) {
            var separator = url.indexOf("?") !== -1 ? "&" : "?";
            hash = url.split("#");
            url = hash[0] + separator + key + "=" + value;
            if (typeof hash[1] !== "undefined" && hash[1] !== null)
              url += "#" + hash[1];
            return url;
          } else
            return url;
        }
      };

      /* EVENT HANDLERS */
      $("body").on("click", ".bdc-searchfilter-choices-list li", function (event) {
        var filterUrl = $(this).find("label > span").attr("data-filter");
        var ajaxUrl = globals.ajaxUrl + filterUrl.substring(filterUrl.indexOf("?"));
        History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", filterUrl);
        return false;
      });

      $('body').on('click', '.bdc-productsearch-sort-ca span', function () {
        const sortUrl = $(this).attr('data-filter');
        const ajaxUrl = `${globals.ajaxUrl}${sortUrl.substring(sortUrl.indexOf('?'))}`;
        History.pushState({ state: ajaxUrl }, `Blinds Search - ${globals.siteName} has the products you're looking for!`, sortUrl);
        return false;
      });

      $("body").on("change", "#SelectedWidth, #SelectedWidthEigth, #SelectedHeight, #SelectedHeightEigth", function (event) {
        showLoader();
        var widthWhole = $("#SelectedWidth").val();
        var widthEigth = $("#SelectedWidthEigth").val();
        var heightWhole = $("#SelectedHeight").val();
        var heightEigth = $("#SelectedHeightEigth").val();

        if (widthEigth == undefined) {
          widthEigth = 0;
        }
        if (heightEigth == undefined) {
          heightEigth = 0;
        }

        var width = parseFloat(widthWhole) + parseFloat(widthEigth / 8);
        var height = parseFloat(heightWhole) + parseFloat(heightEigth / 8);

        var url = window.location.href;

        url = updateQueryString("height", height, url);
        url = updateQueryString("width", width, url);

        var ajaxUrl = globals.ajaxUrl + url.substring(url.indexOf("?"));

        History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);

        persistHeightWidth();
      });

      $("body").on("click", "#see-more-products-btn", function (event) {
        var url = $(this).attr("href");
        var ajaxUrl = globals.ajaxUrl + url.substring(url.indexOf("?"));
        History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);
        return false;
      });

      $("body").on("click", ".bdc-pagination-link", function (event) {
        var url = $(".bdc-pagination-list").data("url");

        var nextPage = $(this).data("value");

        if (nextPage) {
          url += "&page=" + nextPage;
        }

        var ajaxUrl = globals.ajaxUrl + url.substring(url.indexOf("?"));
        History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);
        return false;
      });

      $("body").on("click", ".bdc-productsearch-results-filter", function (event) {
        $(".bdc-searchfilter").addClass("bdc-searchfilter-show");
      });

      $("body").on("click", "#bdc-searchfilter-done", function (event) {
        $(".bdc-searchfilter").removeClass("bdc-searchfilter-show");
        return false;
      });

      $("body").on("change", "#bdc-productsearch-results-sort-items", function (event) {
        var url = window.location.href;
        var sorts = $(this).val();
        var ajaxUrl = globals.ajaxUrl + window.location.search;
        url = updateQueryString("sorts", sorts, url);
        ajaxUrl = updateQueryString("sorts", sorts, ajaxUrl);
        History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);
      });

      $("body").on("click", ".bdc-productwidget-colors-count", function (event) {
        var productId = $(this).data("productid");
        var url = "/Catalog/Category/GetColorSwatchByProductId?productId=" + productId;
        var colorswatchElement = "#bdc-productsearch-colors-" + productId;
        $("#bdc-productsearch-colors-" + productId + " ul").empty();
        $.get(url, function (data) {
          $.each(data, function (key, val) {
            var imageUrl = "/product-images/" + val.ImageUniqueId + ".jpg?width=20&height=20";
            $("#bdc-productsearch-colors-" + productId + " ul").append("<li style='background-image: url(" + imageUrl + ")'></li>");
          });
        });
        $(colorswatchElement).show();
      });

      $(".bdc-productwidget-colors-count").mouseout(function () {
        $(".bdc-productsearch-colors").hide();
      });

      $("body").on("change", ".bdc-estimate-search-filter", function (event) {
        setEstimateFilters();
      });

      $("body").on("change", "select.bdc-estimate-search-filter", function (event) {

        setEstimateFilters();

        var widthWhole = $("#bdc-estimate-search-width-whole-select").val();
        var widthEigth = $("#bdc-estimate-search-width-eigth-select").val();
        var heightWhole = $("#bdc-estimate-search-height-whole-select").val();
        var heightEigth = $("#bdc-estimate-search-height-eigth-select").val();

        if (widthEigth == undefined) {
          widthEigth = 0;
        }
        if (heightEigth == undefined) {
          heightEigth = 0;
        }

        var width = parseFloat(widthWhole) + parseFloat(widthEigth / 8);
        var height = parseFloat(heightWhole) + parseFloat(heightEigth / 8);

        var url = window.location.href;

        url = updateQueryString("height", height, url);
        url = updateQueryString("width", width, url);

        var sortBy = $("#bdc-estimate-search-sortby-select").val();

        url = updateQueryString("sorts", sortBy, url);

        var ajaxUrl = globals.ajaxUrl + url.substring(url.indexOf("?"));

        History.pushState({ state: ajaxUrl }, "Blinds Search - " + globals.siteName + " has the products you're looking for!", url);

        persistHeightWidth();
      });

      $("body").on("click", ".bdc-searchfilter-options-title.collapsable", function () {
        var link = $(this);
        var list = $(this).next(".bdc-searchfilter-options-list");
        $(list).slideToggle("300", () => {
          // Animation complete.
          var icon = link.find("span.bdc-font");
          if (list.is(":visible")) {
            icon.removeClass("bdc-font-plussign");
          } else {
            icon.addClass("bdc-font-plussign");
          }
        });
      });
      History.pushState({ state: globals.ajaxUrl }, document.title);
      History.Adapter.bind(window, "statechange", function () {
        var state = History.getState().data.state;
        showLoader();
        $.get(state, {}, function (data) {
          $(".main-content").replaceWith(data);

          if (useDelorean) {
            fave();
          }

          if (globals.isEstimateSearch) {
            setEstimateFilters();
          }
        });
      });

      var isMobile = globals.ssm.states[0].active;
      if (isMobile) {
        $("body").on("touchstart", function (event) {
          var $elem = $(event.target);
          //filter results
          if ($elem.hasClass("bdc-productsearch-results-filter") || $elem.hasClass("bdc-font-filter")) {
            $("#bdc-search-filter").addClass("bdc-searchfilter-show");
          }
        });
      }

      /* INITIALIZATION */
      persistHeightWidth();
    });
  });
